import { Modal } from "reactstrap";
import { down, up } from "styled-breakpoints";
import styled from "styled-components";


export const CustomModal = styled(Modal)`
  max-width: 700px;
  --bs-modal-width: 566px;
  border-radius: 22px;
  .modal-content {
    padding: 20px !important;
    ${up("md")} {
      padding: 36px !important;
    }
    border-radius: 22px;
    max-height: 90vh;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .modal-content::-webkit-scrollbar {
    display: none;
  }
  .modal-header {
    border-bottom: none !important;
    h5 {
      display: block;
      font-family: "Kamerik 205", sans-serif;
      font-size: 1.5em;
      font-weight: 700;
      letter-spacing: -.06em;
      line-height: .98;
      ${up("md")} {
        font-size: clamp(30px, 4vw, 32px);
        line-height: normal;
      }
      span{
        &.title {
          letter-spacing: 1%;
          line-height: 110%;
          em {
            font-style: normal;
            &.primary{
              color: var(--color-primary);
            }
            &.secondary{
              color: var(--color-secondary);
            }
          }
        }
        &.subtitle{
          display: block;
          max-width: 525px;
          margin-top: 12px;
          font-family: Halenoir, sans-serif;
          font-size: 16px;
          font-weight: 400;
          letter-spacing: normal;
          color: var(--color-text-slight-dark);
          ${down("md")}{
            font-size: 14px;
          }
        }
      }
    }
    .business-pricing-title {
      display: block;
      /* font-weight: 800;
      letter-spacing: -5%;
      font-size: 27.6284px; */

        em {
          color: #ffa32b;
          font-style: normal;
        }
      }

    .btn-close {
      display: none;
    }
    .close-btn {
      position: absolute;
      top: 4px;
      ${up("md")} {
        top: 7px;
      }
      right: 4px;
      cursor: pointer;
    }
  }
  .modal-body {
    .row {
    --bs-gutter-x: 16px;
    --bs-gutter-y: 0;

    .form-label {
      margin-bottom: 7px;
      color: #292d32;
      font-family: Halenoir, sans-serif;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: .02em;

      span {
        color: #ff3d3d;
      }
    }

    .form-control {
      min-height: 49px;
      border: 1px solid #cfd2d0;
      border-radius: 999px;
      padding: 12px 14px;
      color: #292d32;
      font-family: Halenoir, sans-serif;
      font-size: 14px;
      ${down("md")}{
        min-height: 30px;
      }
      &::placeholder {
        color: #c4c7c5;
      }

      &:focus {
        border-width: 1.5px;
        box-shadow: none;
      }
    }

    .business-type-select {
      display: flex;
      position: relative;
      z-index: 2;
      width: 100%;

      .action-select-trigger {
        width: 100%;
        min-height: 49px;
        padding: 12px 14px;
        border: 1px solid #cfd2d0 !important;
        border-radius: 999px;
        background: #fff !important;
        color: #292d32 !important;
        font-family: Halenoir, sans-serif;
        font-size: 14px;
        font-weight: 400;

        &:focus-visible {
          border-color: #ffa32b;
          outline: none;
        }

        svg {
          width: 16px;
          height: 16px;
        }
      }

      &.is-placeholder .action-select-trigger {
        color: #8f9491 !important;
      }

      .action-select-menu {
        width: 100%;
        min-width: 100%;
        border-color: #cfd2d0;
        border-radius: 16px;
        box-shadow: 0 12px 24px rgb(41 45 50 / 12%);
        z-index: 1065;
      }

      .action-select-option {
        color: #292d32;
        font-weight: 400;
      }

      &.is-invalid .action-select-trigger {
        border-color: #dc3545;
      }
    }
    }

    .business-pricing-help {
      margin: 0;
      color: #ff3d3d;
      font-family: Halenoir, sans-serif;
      font-size: 13px;
      line-height: 1.25;
    }

    .business-pricing-extra-field {
      margin-top: 18px;

      .business-produce-options {
        display: grid;
        gap: 8px;
        margin-top: 8px;

        label,
        .business-consultation-check label {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #292d32;
          font-family: Halenoir, sans-serif;
          font-size: 13px;
        }

        input,
        & + input {
          accent-color: #0b9c07;
        }
      }

      .flatpickr-input {
        width: 100%;
      }
    }

    .business-consultation-check {
      margin-top: 16px;

      label {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #292d32;
        font-family: Halenoir, sans-serif;
        font-size: 13px;
      }

      input { accent-color: #0b9c07; }
    }

    .same-as-phone-check {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
      color: #292d32;
      font-family: Halenoir, sans-serif;
      font-size: 12px;
      cursor: pointer;

      input { accent-color: #0b9c07; }
    }
    .mb-3 {
      margin-bottom: 1.5rem !important;
    }
    ${down("md")}{
      .contact-us-fields, .business-pricing-fields{
      .col-md-6 > .mb-3{
        margin-bottom: 1rem!important;
      }
    }
    }
    .contact-us-fields {
      textarea.form-control {
        min-height: 140px;
        border: 1px solid #cfd2d0;
        border-radius: 18px;
        padding: 14px;
        resize: vertical;

        &:focus {
          border-color: #0b9c07;
          box-shadow: 0 0 0 3px rgb(11 156 7 / 10%);
        }
      }
    }
  }
  .modal-footer {
    border-top: none !important;
    justify-content: center;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 36px;
      background: #0b9c07;
      padding: 8.5px;
      font-weight: 600;
      font-size: 20px;
      width: 100%;
      border: none;
      svg {
        margin-left: 4px;
      }
    }
  }



  &.business-pricing-modal {
    .modal-footer {
      button {
        min-height: 50px;
        background: #ffa32b;
        color: #fff;
        font-family: Halenoir, sans-serif;
        font-size: 14px;

        &:hover,
        &:focus-visible {
          background: #ed9017;
        }
      }
    }
  }
`;
